var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68071 5.79172L7.34399 7.75L5.68071 9.70829C4.6057 10.7685 2.8748 10.7639 1.80546 9.69454C0.731515 8.6206 0.731515 6.8794 1.80546 5.80546C2.8748 4.73611 4.6057 4.73153 5.68071 5.79172ZM8 6.97764L6.41603 5.11273L6.40165 5.09835C4.93718 3.63388 2.56282 3.63388 1.09835 5.09835C-0.366117 6.56282 -0.366117 8.93718 1.09835 10.4017C2.56282 11.8661 4.93718 11.8661 6.40165 10.4017L6.41603 10.3873L8 8.52236L9.58397 10.3873L9.59835 10.4017C11.0628 11.8661 13.4372 11.8661 14.9017 10.4017C16.3661 8.93718 16.3661 6.56282 14.9017 5.09835C13.4372 3.63388 11.0628 3.63388 9.59835 5.09835L9.58397 5.11273L8 6.97764ZM8.65601 7.75L10.3193 5.79172C11.3943 4.73153 13.1252 4.73611 14.1945 5.80546C15.2685 6.8794 15.2685 8.6206 14.1945 9.69454C13.1252 10.7639 11.3943 10.7685 10.3193 9.70829L8.65601 7.75Z",
    fill: "#6E97FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops);
export default __webpack_public_path__ + "static/media/Devops.e6f65868ffc754506f3563d029c34ad6.svg";
export { ForwardRef as ReactComponent };